<div class="title title-basic text-center">
  <h1>Welcome to the Agent BQX UI</h1>
  <h3 class="sub-heading">What would you like to do today?</h3>
</div>

<div class="homepage-container">
  <div class="homepage-box">
    <button mat-stroked-button color="primary" routerLink="/application_form" routerLinkActive="active" class="mat-focus-indicator icon-button mat-stroked-button mat-button-base mat-primary" (click)="newQuoteOnClick($event)">
      <span class="mat-button-wrapper">
        <i class="material-icons homepage-icon-button mat-icon-not-loaded">note_add</i>
        <h3 class="button-title">New Quote</h3>
      </span>
      <span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
      <span class="mat-button-focus-overlay"></span>
    </button>
  </div>

  @if (displaySearch) {
    <div class="homepage-box">
      <button mat-stroked-button color="primary" routerLink="/search_forms" routerLinkActive="active" class="mat-focus-indicator icon-button mat-stroked-button mat-button-base mat-primary" (click)="newSearchOnClick($event)">
        <span class="mat-button-wrapper">
          <i class="material-icons homepage-icon-button mat-icon-not-loaded">search</i>
          <h3 class="button-title">Search Quotes</h3>
        </span>
        <span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
        <span class="mat-button-focus-overlay"></span>
      </button>
    </div>
  }
</div>